"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOWNLOAD_QR_LINK_URL = exports.GhostIconFilledIconUrl = exports.toWebDownloadPageUrl = exports.toAppStoreUrl = exports.UNLOCK_DEEPLINK_URL = void 0;
exports.UNLOCK_DEEPLINK_URL = "https://link.snapchat.com/unlock";
const toAppStoreUrl = (pageTypeName) => `https://apps.apple.com/app/apple-store/id447188370?pt=614006&ct=${pageTypeName}&mt=8`;
exports.toAppStoreUrl = toAppStoreUrl;
const toWebDownloadPageUrl = (pageTypeName) => `https://www.snapchat.com/download?purpose=snapchat_dot_com&sp=${pageTypeName}`;
exports.toWebDownloadPageUrl = toWebDownloadPageUrl;
exports.GhostIconFilledIconUrl = "https://static.snapchat.com/images/ghost-icon-filled.png";
// Static link that's used in the QR code on the homepage.
// This has TTL of 2 years, until 11th October 2025.
// This would be replaced by a dynamic link in the future.
exports.DOWNLOAD_QR_LINK_URL = "https://snapchat.com/t/TCDcelvF";
//# sourceMappingURL=urls.js.map